import { Card, CardBody, Col, Row } from 'reactstrap'
import { VariationsOfLeftRibbons } from '../../../../utils/Constant'
import { leftRibbonsData } from '../../../../Data/BonusUi/Ribbons/Ribbons'
import StaticLeftRibbons from './StaticLeftRibbons'
import DynamicLeftRibbons from './DynamicLeftRibbons'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const LeftRibbons = () => {
  return (
    <Row>
      <Col sm="12" xl="12">
        <Card>
          <CommonCardHeader title={VariationsOfLeftRibbons} span={leftRibbonsData} />
          <CardBody>
            <Row className="g-3">
              <StaticLeftRibbons />
              <DynamicLeftRibbons />
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default LeftRibbons